(() => {
  const root = document.querySelector('[data-lyfe-archive]');
  if (!root) return;
  const batchContainer = root.querySelector('[data-archive-batches]');
  const sort = root.querySelector('[data-archive-sort]');
  const options = [...root.querySelectorAll('[data-archive-sort-option]')];
  const empty = root.querySelector('[data-archive-empty]');
  const batches = [...root.querySelectorAll('[data-archive-batch]')];
  const getOrder = () => new URL(window.location.href).searchParams.get('archive_sort') === 'oldest' ? 'oldest' : 'newest';
  const applyOrder = () => {
    const order = getOrder();
    [...batches]
      .sort((a, b) => order === 'oldest' ? Number(a.dataset.batchNumber) - Number(b.dataset.batchNumber) : Number(b.dataset.batchNumber) - Number(a.dataset.batchNumber))
      .forEach(batch => batchContainer.append(batch));
    options.forEach(option => {
      const selected = option.dataset.archiveSortOption === order;
      option.classList.toggle('is-selected', selected);
      if (selected) option.setAttribute('aria-current', 'page');
      else option.removeAttribute('aria-current');
    });
    if (empty) empty.hidden = batches.length > 0;
  };
  options.forEach(option => option.addEventListener('click', event => {
    event.preventDefault();
    const url = new URL(window.location.href);
    url.searchParams.set('view', 'archive');
    url.searchParams.set('archive_sort', option.dataset.archiveSortOption);
    window.history.pushState({}, '', url);
    applyOrder();
    sort.open = false;
  }));
  document.addEventListener('click', event => {
    if (sort.open && !sort.contains(event.target)) sort.open = false;
  });
  window.addEventListener('popstate', applyOrder);
  applyOrder();
})();
